import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

/**
 * @additionalProperties false
 */
export interface Section {
    id: string;
    name?: string;
    features?: string[];
    messages?: Message[];
}

/**
 * @additionalProperties false
 */
export interface Message {
    id?: string;
    label?: string;
    features?: string[];
    localizations?: LocalizedMessage[];
}

/**
 * @additionalProperties false
 */
export interface LocalizedMessage {
    locale?: string;
    value?: string;
}

/**
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.StandardTexts)
@ComponentConfigurationClass("standardTexts")
export class StandardTextsConfiguration {
    /**
     * @format custom-hidden
     */
    public locales?: string[];

    /**
     * @format custom-hidden
     */
    public defaultLocale?: string;

    /**
     * It is expected that all messages keys (Message.id) are unique across configuration
     *
     * @featured [PU_FILE_UPLOAD] message-file-upload-question-select-files
     * @featured [PU_FILE_UPLOAD] message-loading-status
     * @featured [PU_FILE_UPLOAD] message-file-upload-question-max-files
     * @featured [PU_FILE_UPLOAD] message-file-upload-question-max-filesize
     * @featured [PU_FILE_UPLOAD] message-mandatory-file-upload
     * @featured [PU_FILE_UPLOAD] message-file-upload-question-not-image
     *
     * @featured [FILTERS] message-filter-restart
     * @featured [FILTERS] message-filter-collapse-all
     * @featured [FILTERS] message-filter-expand-all
     * @featured [FILTERS] message-filter-more
     * @featured [FILTERS] message-filter-less
     *
     * @featured [PDF_TEMPLATES] message-button-pdf-download
     * @featured [PDF_TEMPLATES] message-filename-pdf-download
     *
     * @format custom-standard-texts
     */
    public sections?: Section[];
}
